// parses anonymized social security number and returns birthdate in ddMMyy format
export const formatBirthdate = (date: string) => {
  let bd
  const ddMM = date.slice(0, 2) + '.' + date.slice(2, 4)
  const yy = date.slice(4, 6)

  const bornIn1800s = date.slice(6, 7) === '+'

  const bornIn1900s =
    date.slice(6, 7) === '-' ||
    date.slice(6, 7) === 'Y' ||
    date.slice(6, 7) === 'X' ||
    date.slice(6, 7) === 'W' ||
    date.slice(6, 7) === 'V' ||
    date.slice(6, 7) === 'U'

  const bornIn2000s =
    date.slice(6, 7) === 'A' ||
    date.slice(6, 7) === 'B' ||
    date.slice(6, 7) === 'C' ||
    date.slice(6, 7) === 'D' ||
    date.slice(6, 7) === 'E' ||
    date.slice(6, 7) === 'F'

  if (bornIn1800s) {
    bd = ddMM + '.18' + yy
  } else if (bornIn1900s) {
    bd = ddMM + '.19' + yy
  } else if (bornIn2000s) {
    bd = ddMM + '.20' + yy
  }

  return bd
}
